import { connect } from 'react-redux';
import compose from 'recompose/compose';
import CancelOrderModal from './cancel-order-modal';
import {
  getContractsSigned,
  getCustomerIsGreen,
  getIsNRSF,
  getOrderSummary
} from '../../../../../../ducks/selectors';

const mapStateToProps = state => ({
  orderSummary: getOrderSummary(state),
  contractsSigned: getContractsSigned(state),
  customerIsGreen: getCustomerIsGreen(state),
  isNRSF: getIsNRSF(state)
});

export default compose(connect(mapStateToProps))(CancelOrderModal);
